/*import Plyr from 'plyr';*/
import {isInViewport, loadLibrary} from "./Util";
import {LIB_URL} from '../App';

const videos = [...document.querySelectorAll('.text video,.video-block')];
const broadcasts = [...document.querySelectorAll('.broadcast-block')];
const videoTriggers = [];

if (videos.length) {
    loadLibrary(LIB_URL.PLYR, renderPlyr);
}

function renderPlyr(){
    videos.forEach(el => {
        const plyrParent = $(el).closest('.js-plyr-parent')[0];

        let options = {
            clickToPlay: false,
            keyboard: false,
            controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen']
        };

        if ($(el).closest('.js-delayed-video').length) {
            const videoDuration = $(el)[0].duration;
            const currentPlayingTime = Math.floor((Date.parse(new Date()) - Date.parse($(el).closest('.js-delayed-video').data('start-time'))) / 1000);

            if (currentPlayingTime < videoDuration) {
                options.controls = ['play-large', 'play', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
            }
        }

        const player = new Plyr(el, options);

        if (plyrParent) {
            plyrParent.getPlyr = () => player;
        }

        player.on('ready', (e) => {
            if (el.classList.contains('js-play-in-view')) {
                videoTriggers.push(el);
                playInView();
                player.volume = 0;
                $(e.target).one('click', () => {
                    videoTriggers.splice(videoTriggers.indexOf(el), 1);
                });
            }

            if ($(el).closest('.js-delayed-video').length) {
                const currentPlayingTime = Math.floor((Date.parse(new Date()) - Date.parse($(el).closest('.js-delayed-video').data('start-time'))) / 1000);

                if (currentPlayingTime < $(el)[0].duration) {
                    player.currentTime = currentPlayingTime;
                    player.play();
                }
            }
        });

        const container = $(player.elements.container);

        container
            .addClass('plyr--once-hide-controls')
            .one('click', () => {
                container.removeClass('plyr--once-hide-controls');
            });
    });
}

const plyrPromise = new Promise(resolve => {
    if (videos.length || broadcasts.length) {
        loadLibrary(LIB_URL.PLYR, function () {
            videos.forEach(plyrRender);

            if (document.querySelectorAll('.js-play-in-view').length) {
                App.W.on('scrolled', playInView);
            }
            resolve();
        });
    } else {
        resolve();
    }
});

function plyrRender(el, options = {}) {
    const player = new Plyr(el, options);

    player.on('ready', (e) => {
        if (el.classList.contains('js-play-in-view')) {
            videoTriggers.push(el);
            playInView();
            player.volume = 0;
            $(e.target).one('click', () => {
                videoTriggers.splice(videoTriggers.indexOf(el), 1);
            });
        }
    });

    const container = $(player.elements.container);

    container
        .addClass('plyr--once-hide-controls')
        .one('click', () => {
            container.removeClass('plyr--once-hide-controls');
        });

    return player;
}

function playInView() {
    videoTriggers.forEach(el => {
        if (isInViewport(el)) {
            el.plyr.play();
            $(el.plyr.elements.container).removeClass('plyr--once-hide-controls');
        } else {
            el.plyr.pause();
        }
    });
}

export {plyrPromise, plyrRender};
